import { useEffect, useState } from 'react'
import { FieldValues, UseFormSetValue } from 'react-hook-form'

import { Box, Stack, Typography } from '@mui/material'
import { DataService } from 'api/DataService'
import CostCenterForm from 'templates/AccountsPayable/components/ConfigurationDrawer/Steps/CostCenterForm'

import AutocompleteAdd from 'components/AutocompleteAdd/AutocompleteAdd'

type Record = {
  label: string
  value: string
  color: string
}

type CostCenterAutocompleteProps<T extends FieldValues> = {
  setValue?: UseFormSetValue<T>
  value: Omit<Record, 'color'> | any
  onChange: any
  errorMessage?: string
  showAddButton?: boolean
}

const CostCenterAutocomplete = <T extends FieldValues>({
  value,
  onChange,
  errorMessage,
  setValue,
  showAddButton = true
}: CostCenterAutocompleteProps<T>) => {
  const [costCenters, setCostCenters] = useState<any[]>()
  // Incrementa depois de criar um item novo pelo "Adicionar", pra lista ser rebuscada
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    const fetchCostCentersAutocomplete = async () => {
      const response = await DataService({
        type: 'GET',
        url: '/v1/accounts_payables/cost_centers/autocomplete'
      })

      setCostCenters(
        response.data.records.map(
          (costCenter: { name: any; uuid: any; color: any }) => ({
            label: costCenter.name,
            value: costCenter.uuid,
            color: costCenter.color
          })
        )
      )
    }

    fetchCostCentersAutocomplete()
  }, [reloadKey])

  return (
    <>
      <AutocompleteAdd
        showAddButton={showAddButton}
        addPermission="accounts_payable:manage"
        key={value?.value}
        {...{ value, onChange, setValue, errorMessage }}
        addButtonText="Adicionar centro de custo "
        label="Centro de custo"
        placeholder="Selecione o centro de custo"
        modalTitle="Novo centro de custo"
        options={costCenters || []}
        renderOption={(props, option) => {
          const optionTyped = option as Record
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { style, ...rest } = props

          return (
            <Box component="li" sx={{ all: 'unset' }} {...rest}>
              <Stack direction="row" alignItems="center" gap="15px" py={1}>
                <Box
                  sx={{
                    height: '9px',
                    width: '9px',
                    bgcolor: `#${optionTyped.color}`,
                    borderRadius: '999px'
                  }}
                ></Box>
                <Typography>{optionTyped.label}</Typography>
              </Stack>
            </Box>
          )
        }}
        modalBodyComponent={
          <CostCenterForm
            onCreated={(item) => {
              // seleciona o item novo no campo de quem usa o autocomplete
              onChange(null, { label: item.name, value: item.uuid })
              setReloadKey((key) => key + 1)
            }}
            handleClose={() => {
              return
            }}
          />
        }
      />
    </>
  )
}

export default CostCenterAutocomplete
